<script setup lang="ts">
import ServiceSetting from "@/views/playground/planner/order-management/service-setting/ServiceSetting.vue";
</script>

<template>
  <service-setting></service-setting>
</template>

<style scoped></style>
